/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import ApiCaller from "api/apiCaller";
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

const PolygonInfoModal = ({
  initialIsOpen,
  geoJson,
  onPolygonSaved,
  planningPolygonToEdit,
  onCancelled,
}) => {
  const [modal, setModal] = useState(initialIsOpen);
  const [polygonInfo, setPolygonInfo] = useState(
    planningPolygonToEdit?.properties || {}
  );

  const [isLoading, setLoading] = useState(false);

  const toggle = () => {
    setModal(!modal);
    if (onCancelled) {
      onCancelled();
    }
  };

  const updateAttribute = (attributeName, value) => {
    const newPolygonInfo = polygonInfo;
    newPolygonInfo[attributeName] = value;
    setPolygonInfo({
      ...newPolygonInfo,
    });
  };

  const savePolygonInfo = async () => {
    if (isLoading) return;
    setLoading(true);
    let uri = `site_planning_selection_area/`;
    if (planningPolygonToEdit) {
      // Update
      uri = `site_planning_selection_area/${planningPolygonToEdit.properties.id}`;
      const res = await ApiCaller.put(uri, polygonInfo);
      if (res.result) {
        if (onPolygonSaved) {
          onPolygonSaved(res.result);
          toggle();
        }
      }
    } else {
      // Create
      const polygonInfoToSubmit = {
        ...polygonInfo,
        geojson: JSON.stringify(geoJson),
      };
      const res = await ApiCaller.post(uri, polygonInfoToSubmit);
      if (res.result) {
        if (onPolygonSaved) {
          onPolygonSaved(res.result);
          toggle();
        }
      }
    }
    setLoading(false);
  };

  const deletePolygon = async () => {
    const confirmation = window.confirm(
      "Bạn có chắc sẽ xóa vùng lựa chọn này?"
    );
    if (!confirmation) return;
    let uri = `site_planning_selection_area/`;
    if (planningPolygonToEdit) {
      // Update
      uri = `site_planning_selection_area/${planningPolygonToEdit.properties.id}`;
      const res = await ApiCaller.put(uri, { is_active: 0 });
      if (res.result) {
        if (onPolygonSaved) {
          onPolygonSaved(res.result);
          toggle();
        }
      }
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Nhập thông tin</ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label>Tiêu đề cho khu vực</Label>
              <Input
                type="text"
                value={polygonInfo.title}
                onChange={(e) => updateAttribute("title", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label>Mô tả yêu cầu</Label>
              <Input
                type="textarea"
                rows={4}
                value={polygonInfo.description}
                onChange={(e) => updateAttribute("description", e.target.value)}
              />
            </FormGroup>
          </Col>
          {planningPolygonToEdit && (
            <Col xs={12}>
              <p>
                Người tạo:{" "}
                {`${planningPolygonToEdit.properties.user.first_name} ${planningPolygonToEdit.properties.user.last_name}`}
              </p>
              <p>Ngày tạo: {planningPolygonToEdit.properties.created_on}</p>
            </Col>
          )}
        </Row>
        {planningPolygonToEdit && (
          <Row>
            <Col xs={12}>
              <Button size="sm" color="danger" onClick={deletePolygon}>
                Xóa vùng này
              </Button>
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Hủy
        </Button>{" "}
        <Button color="primary" onClick={savePolygonInfo}>
          {isLoading ? "Đang lưu..." : "Lưu"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PolygonInfoModal;
